/* =========================================================================
   MARKETING Hero — Creative Studio: shared types & constants.
   (1) Creative Brief + multiple angles, (2) Artwork review scoring.
   ========================================================================= */

export const CREATIVE_ANGLES = [
  "Pain", "Desire", "Problem", "Solution", "Price", "Offer", "Review", "Authority",
  "Social Proof", "Comparison", "Transformation", "Fear of Loss", "Urgency",
  "Educational", "Contrarian", "Myth Busting", "Case Study",
];
export const CREATIVE_FORMATS = ["ภาพเดี่ยว (Single Image)", "คารูเซล (Carousel)", "วิดีโอสั้น", "Story/Reels"];

export interface CreativeBriefInputs {
  objective?: string; audience?: string; pain?: string; desire?: string;
  offer?: string; platform?: string; format?: string; product?: string; name?: string;
}

export interface CreativeAngle {
  name: string; why: string; bestAudience: string; hook: string; message: string; visual: string; cta: string;
}

export interface CreativeBriefOutput {
  creativeStrategy: string;
  mainAngle: string;
  hook: string;
  headline: string;
  subheadline: string;
  proof: string;
  cta: string;
  keyVisual: string;
  composition: string;
  layout: string;
  visualHierarchy: string;
  imageDirection: string;
  color: string;
  font: string;
  aiImagePrompt: string;
  negativePrompt: string;
  angles: CreativeAngle[];
  disclaimer?: string;
}

export interface CreativeReviewCheck { item: string; score: number; note: string; }
export interface CreativeReviewOutput {
  score: number; // 0-100
  checks: CreativeReviewCheck[];
  criticalIssues: string[];
  importantFixes: string[];
  optionalFixes: string[];
  rewrite: string;
  recommendedLayout: string;
  disclaimer?: string;
}

export const CREATIVE_BRIEF_SCHEMA_HINT = {
  creativeStrategy: "string", mainAngle: "string", hook: "string", headline: "string", subheadline: "string",
  proof: "string", cta: "string", keyVisual: "string", composition: "string", layout: "string",
  visualHierarchy: "string", imageDirection: "string", color: "string", font: "string",
  aiImagePrompt: "string — prompt สำหรับสร้างภาพ AI", negativePrompt: "string",
  angles: [{ name: "string", why: "string", bestAudience: "string", hook: "string", message: "string", visual: "string", cta: "string" }],
};

export const CREATIVE_REVIEW_SCHEMA_HINT = {
  score: 0,
  checks: [{ item: "Hook|Headline|Readability|Mobile|Hierarchy|Contrast|Clutter|Visual Quality|Offer|Proof|CTA|Brand Fit|Conversion", score: 0, note: "string" }],
  criticalIssues: ["string"], importantFixes: ["string"], optionalFixes: ["string"],
  rewrite: "string — เขียนคอปปี้ใหม่", recommendedLayout: "string",
};
